import React from 'react'
import Skeleton from '@material-ui/lab/Skeleton'

const LoaderCharts = () => {
  return (
    <div className="bar_charts_loader_container">
      <div className="loadred_item left">
        {[1, 2, 3].map((i) => {
          return (
            <div className="left_item" key={i}>
              <Skeleton
                variant="rect"
                width={'100%'}
                height={'100%'}
                animation="wave"
                style={{
                  borderRadius: '10px',
                }}
              />
            </div>
          )
        })}
      </div>
      <div className="loadred_item right">
        {[1, 2, 3].map((i) => {
          return (
            <div className="right_item" key={i}>
              <Skeleton
                variant="rect"
                width={`${Math.random() * 100}%`}
                height={'100%'}
                animation="wave"
                style={{
                  borderRadius: '10px',
                }}
              />
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default LoaderCharts
